function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.96 122.88",
    style: {
      enableBackground: "new 0 0 86.96 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.81 96.57c4.42 7.04 9.2 15.57 13.92 23.86 1.75 3.06 3.33 3.52 5.43-.11 4.56-7.91 9.04-16.1 13.76-23.74 14.33-23.19 37.78-45.8 19.13-77.01C63.49-8.14 18.45-5.18 4.98 20.62c-15.44 29.57 8.67 53.41 22.83 75.95z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ea4335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46 25.59c9.31 0 16.86 7.55 16.86 16.86s-7.55 16.86-16.86 16.86c-9.31 0-16.86-7.55-16.86-16.86s7.55-16.86 16.86-16.86z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a60d0d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.66d9d7baee89c9c3bdf57876928b4f58.svg";
export { ForwardRef as ReactComponent };